module.exports = __webpack_public_path__ + "img/汽车滑轨2.c0f03dc6.jpg";